import { axiosClient } from "../client";
import axios from "axios";

const METRICS_INFO_GET_ALL = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getAllMetrics`;

const GET_CUSTOMER_INFO_USING_LOCATION_ID = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getClientId`;

const GET_ALERT_CONFIG_INFO = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getAlert`;

const ALERT_CONFIG_UPDATE = (locationId, id) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/updateAlert/${id}`;

const ALERT_CONFIG_DELETE = (locationId, id) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/deleteAlert/${id}`;

const ALERT_CONFIG_CREATE = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/createAlert`;

const SAVE_LAYOUT = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/saveLayout`;

const UPDATE_LAYOUT = (locationId, widgetId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/updateLayout/${widgetId}`;

const GET_LAYOUT = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getLayout`;

const GET_SINGLE_LAYOUT = (locationId, layoutId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getLayout/${layoutId}`;

const UPDATE_RESET_HOUR = (locationId, layoutId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/resetHour`;

const GET_RESET_HOUR = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getHour`;

const DELETE_METRICS = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/removeMetrics`;

const GET_DISPLAY_INFO = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS}/core/modules/${locationId}/displays`;

const GET_ALERT_AVAILABILITY_INFO = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/getAlertAvailability`;

const ALERT_AVAILABILITY_UPDATE = (locationId, id) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/updateAlertAvailability`;

const ALERT_AVAILABILITY_CREATE = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_INSIGHT}/location/${locationId}/createAlertAvailability`;

export const fetchAllMetricsInfo = (locationId) =>
  axiosClient({
    method: "GET",
    url: METRICS_INFO_GET_ALL(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const fetchCustomerInfoUsingLocationId = (locationId) =>
  axiosClient({
    method: "GET",
    url: GET_CUSTOMER_INFO_USING_LOCATION_ID(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const fetchAlertConfigInfo = (locationId) =>
  axiosClient({
    method: "GET",
    url: GET_ALERT_CONFIG_INFO(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const updateAlertConfigInfo = (locationId, data, id) =>
  axiosClient({
    method: "PUT",
    url: ALERT_CONFIG_UPDATE(locationId, id),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const deleteAlertConfigInfo = (locationId, id) =>
  axiosClient({
    method: "DELETE",
    url: ALERT_CONFIG_DELETE(locationId, id),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const createAlertConfigInfo = (locationId, data) =>
  axiosClient({
    method: "POST",
    url: ALERT_CONFIG_CREATE(locationId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const fetchDisplayInfo = (locationId) =>
  axios({
    axiosClient: "GET",
    url: GET_DISPLAY_INFO(locationId),
    headers: {},
  });

export const fetchAlertAvailabilityInfo = (locationId) =>
  axiosClient({
    method: "GET",
    url: GET_ALERT_AVAILABILITY_INFO(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const updateAlertAvailabilityInfo = (locationId, data) =>
  axiosClient({
    method: "PUT",
    url: ALERT_AVAILABILITY_UPDATE(locationId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const createAlertAvailabilityInfo = (locationId, data) =>
  axiosClient({
    method: "POST",
    url: ALERT_AVAILABILITY_CREATE(locationId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const saveLayout = (locationId, data) =>
  axiosClient({
    method: "POST",
    url: SAVE_LAYOUT(locationId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const updateLayout = (locationId, data, widgetId) =>
  axiosClient({
    method: "PUT",
    url: UPDATE_LAYOUT(locationId, widgetId),
    data,
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const getLayout = (locationId) =>
  axiosClient({
    method: "GET",
    url: GET_LAYOUT(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const getSingleLayout = (locationId, layoutId) =>
  axios({
    method: "GET",
    url: GET_SINGLE_LAYOUT(locationId, layoutId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

export const updateResetHour = (locationId, data) =>
  axiosClient({
    method: "PUT",
    url: UPDATE_RESET_HOUR(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
    data,
  });

export const getResetHour = (locationId) =>
  axiosClient({
    method: "GET",
    url: GET_RESET_HOUR(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });

  export const removeMetrics = (locationId) =>
  axiosClient({
    method: "DELETE",
    url: DELETE_METRICS(locationId),
    headers: {
      "X-Role-Location": locationId,
      "Content-Type": "application/json",
    },
  });
